import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { canPeek } from '../../utils';
import { CommentContext } from '../../CommentContext';
import CommentDataAttrDiv from '../../lego/CommentDataAttrDiv';
import s from './SpamView.scss';
const SpamView = ()=>{
    const { t  } = useTranslation();
    const { setPeeking , comment  } = useContext(CommentContext);
    const isPeekable = canPeek(comment);
    const Tag = isPeekable ? PlainButtonOrLink : 'div';
    return /*#__PURE__*/ React.createElement(CommentDataAttrDiv, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Tag, {
        className: s['spam'],
        onClick: isPeekable ? ()=>setPeeking(true) : undefined
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['spam-text']
    }, /*#__PURE__*/ React.createElement(ErrorIcon, {
        className: s['hidden-icon']
    }), t('comment.visibility.spam'))));
};
SpamView.displayName = 'SpamView';
export default SpamView;
